/**
 * Ordering helpers shared by every editorial picker (CMS-06 song list, CMS-08 rows and items).
 * Order is data — `playlist_songs.position`, `home_rows.position`, `home_row_items.position` —
 * so moving is a pure array operation and the screens stay testable without a DnD library.
 */

/** Moves `from` to `to`, returning the same array when the move is a no-op. */
export function move<T>(list: readonly T[], from: number, to: number): T[] {
  if (from === to || from < 0 || to < 0 || from >= list.length || to >= list.length) {
    return [...list];
  }
  const next = [...list];
  const [item] = next.splice(from, 1);
  next.splice(to, 0, item!);
  return next;
}

export function removeAt<T>(list: readonly T[], index: number): T[] {
  return list.filter((_, i) => i !== index);
}

/** Appends unless `isSame` already matches an entry (pickers never add twice). */
export function appendUnique<T>(list: readonly T[], item: T, isSame: (a: T, b: T) => boolean): T[] {
  return list.some((entry) => isSame(entry, item)) ? [...list] : [...list, item];
}
